import { useMemo } from "react";
import { SelectOptions } from "../select-options";
import { MapPinIcon } from "@/components/assets/icons";
import { AddressType } from "@/enums";
import { useGetDeliveryAddressesForShipmentRequest } from "@/api/useGetDeliveryAddressesForShipmentRequest";
import { OptionType } from "../select";

export default function SelectPreDeliveryAddressFlow({
  onSelect,
  selectedOption,
}: {
  onSelect: (selectedValue: any) => void;
  selectedOption: OptionType;
}) {
  const { data } = useGetDeliveryAddressesForShipmentRequest();

  const addressOptions = useMemo(() => {
    return data?.data?.data
      ?.filter((address) => address.addressBaseType === AddressType.DELIVERY)
      ?.map((address) => {
        const option = {
          id: address.addressId,
          mainText: address.addressLabel,
          secondaryText: address.streetName,
          icon: <MapPinIcon />,
        };
        return option;
      });
  }, [data]);

  return (
    <SelectOptions
      options={addressOptions}
      selectedOption={selectedOption}
      onSelect={onSelect}
      searchPlaceholder="Search for pre-delivery address"
    />
  );
}
